<template>
    <div id="app">
        <div class="row">
            <aside class="col-3 col-12-sm sticky-filter">
                <div class="news-filter">
                    <form>
                        <input v-model="search"
                               type="text"
                               placeholder="Suche">
                        <div class="radio-wrap" v-for="category in orderedCategories">
                            <label :for="category.id" class="container">{{category.name}}
                                <input type="radio" :id="category.id" :value="category.id" v-model="categoryFilter">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </form>
                </div>
            </aside>
            <div id="newslist" class="col-9 col-12-sm">
                <template v-for="(value, index) in filteredResults">
                    <h2 v-if="checkDate(value.date, filteredResults[checkIndex(index)].date, index)"
                        v-html="getMonth(value.date, filteredResults[checkIndex(index)].date)"></h2>
                    <div class="teaser" v-bind:class="{ upright: value.upright }">
                        <figure v-lazy-container="{ selector: 'img' }">
                            <img :data-src="value.img_url"/>
                            <!--<img v-lazy="value.img_url"/>-->
                            <footer>
                                <small v-if="value.img_caption"
                                       v-html="value.img_caption"></small>
                            </footer>
                        </figure>
                        <div class="teaser__info">
                            <!--<span class="news-date" v-html="value.date">value.date</span>-->
                            <h3><a v-html="value.title" :href="value.link" tabindex="-1"></a></h3>
                            <p v-html="value.excerpt.substring(0,60) + ' ...'"></p>
                        </div>
                        <a :href="value.link" v-html="linktext" class="btn"></a>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';

    var lang = document.getElementsByTagName('html')[0].getAttribute('lang');

    export default {
        name: 'App',
        data() {
            return {
                posts: wpseVars.news,
                categories: [],
                search: '',
                categoryFilter: '',
                result: '',
                linktext: ''
            }
        },
        computed: {
            filteredResults: function () {
                const pattern = new RegExp(this.search, 'i'), // match keyword against post titles or excerpts.
                    cat_id = Number(this.categoryFilter);
                if (this.posts) {
                    return this.posts.filter(post => {
                        return (
                            (post.title.match(pattern) || post.content.match(pattern)) && Object.values(post.categories).includes(cat_id)
                        );
                    });
                }
            },
            orderedCategories: function () {
                return _.orderBy(this.categories, 'slug')
            },
        },
        created: function () {
            this.fetchCategories();
            this.setTranslations();
        },
        methods: {
            fetchCategories: function () {
                var allCategories,
                    self = this;

                    allCategories = wpseVars.categories;
                    for (var i = 0; i < allCategories.length; i++) {
                            self.categories.push(allCategories[i]);
                    }
                    self.categoryFilter = _.orderBy(self.categories, 'slug')[0].id;
            },
            checkDate: function (curDate, prevDate, index) {
                var curMonth = curDate.split('.')[1],
                    prevMonth = prevDate.split('.')[1];
                if (curMonth != prevMonth || index === 0) {
                    return true;
                } else {
                    return false;
                }
            },
            getMonth: function (curDate, prevDate) {
                return curDate.split('.')[1] + '/' + curDate.split('.')[2];
            },
            checkIndex: function (index) {
                if (index === 0) return index;
                else return index - 1;
            },
            setTranslations: function () {
                switch (lang.substring(0, 2)) {
                    case 'de':
                        this.linktext = 'Mehr erfahren';
                        break;
                    case 'en':
                        this.linktext = 'Read more';
                        break;
                    case 'ja':
                        this.linktext = '続きを読む';
                        break;
                    default:
                        this.linktext = 'Mehr erfahren';
                        break;
                }
            }

        }
    }
    // setTimeout(console.log(wpseVars.categories), 4000);


</script>